import { first } from 'rxjs/operators'

import { Location, getTranslatedString } from '@skinsoft/types'
import { locationSelectors } from '@skinsoft/selectors'
import { OfflineDataFetcher } from '@skinsoft/offline'

export class LocationOfflineDataFetcher extends OfflineDataFetcher<Location>{
    constructor(cacheKey: string) {
        super(cacheKey);
    }

    private async resolvePath(pathId: string, locale: string, includeLastLevel: boolean = false) {
        let resolvedPath: string = ""
        if (pathId) {
            const ids = pathId.split("/")
            let index = 0;
            const lastlevelOffset = includeLastLevel ? 1 : 0;
            for (const id of ids) {
                if (id && index < ids.length - lastlevelOffset) {
                    const location = await this.fetchOneFromId(id)
                        .pipe(first())
                        .toPromise()
                    const resolveName = getTranslatedString(location?.translatedTitle, locale)
                    resolvedPath += `/${resolveName}`
                }
                index++;
            }
        }
        return resolvedPath
    }

    /**
     * Returns true if the name or the path of the location contains the queryText
     * @param entity 
     * @param queryText 
     * @param locale 
     */
    protected async queryTextFilter(entity: Location, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()

        let titleMatches = false;
        let pathMatches = false;

        // Testing title
        const title: string = locationSelectors.title(entity, locale).toLowerCase() || "";
        if (title) {
            titleMatches = title.includes(lowerCaseQueryText)
        }

        // Testing path
        const path: string = locationSelectors.pathIds(entity)
        const resolvedPath = (await this.resolvePath(path, locale))?.toLowerCase()
        if (resolvedPath) {
            pathMatches = resolvedPath.includes(lowerCaseQueryText)
        }

        return titleMatches || pathMatches;
    }
}